<template>
  <div
    class="container-fluid"
    v-bind:class="{ 'full-screen-container': isFullscreen }"
  >
    <el-row type="flex" justify="center" style="margin-top: 10px">
      <el-col :lg="24" :xl="22">
        <el-card>
          <div slot="header" class="clearfix">
            <span>Schedule Monitor</span>
            <el-button
              style="float: right; padding: 3px 0"
              type="text"
              @click="toggleFullscreen"
              >{{
                isFullscreen ? "Exit Full Screen" : "Full Screen"
              }}</el-button
            >
          </div>
          <el-tabs v-model="activeName">
            <el-tab-pane label="Monitor" name="1">
              <journey-schedules-monitor-table></journey-schedules-monitor-table>
            </el-tab-pane>
            <el-tab-pane label="Manage Schedule" name="2">
              <journeys-schedules-table></journeys-schedules-table>
            </el-tab-pane>
            <el-tab-pane label="Manage Places" name="3">
              <places-table></places-table>
            </el-tab-pane>
            <el-tab-pane label="Manage Contractors" name="4">
              <contractors-table></contractors-table>
            </el-tab-pane>
            <el-tab-pane label="Export KPI Reports" name="5">
              <kpi-exporter></kpi-exporter>
            </el-tab-pane>
            <el-tab-pane label="My Settings" name="6">
              <schedule-monitor-setting :user="user"></schedule-monitor-setting>
            </el-tab-pane>
          </el-tabs>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import JourneySchedulesMonitorTable from "../../components/tables/JourneySchedulesMonitorCarrier";
import JourneysSchedulesTable from "../../components/tables/JourneySchedulesCarrier";
import PlacesTable from "../../components/tables/PlacesCarrier";
import ContractorsTable from "../../components/tables/ContractorsCarrier";
import ScheduleMonitorUsersSetting from "../../components/form/ScheduleMonitorUsersSetting";
import ScheduleMonitorSetting from "../../components/form/ScheduleMonitorSetting";
import KpiExporter from "../../components/form/ScheduleMonitorKpiExporter";

export default {
  // Do not forget this little guy
  name: "ScheduleMonitor",
  // share common functionality with component mixins
  mixins: [],
  // compose new components
  extends: {},
  // component properties/variables
  props: {
    user: {
      required: true,
      type: Object
    }
  },
  // variables
  data() {
    return {
      activeName: "1",
      isFullscreen: false
    };
  },
  computed: {},
  // when component uses other components
  components: {
    JourneySchedulesMonitorTable,
    JourneysSchedulesTable,
    PlacesTable,
    ScheduleMonitorSetting,
    ScheduleMonitorUsersSetting,
    ContractorsTable,
    KpiExporter
  },
  // methods
  watch: {},
  methods: {
    toggleFullscreen(event) {
      const elem = document.documentElement;
      if (
        document.fullscreenEnabled ||
        document.webkitFullscreenEnabled ||
        document.mozFullScreenEnabled ||
        document.msFullscreenEnabled
      ) {
        if (!this.isFullscreen) {
          if (elem.requestFullscreen) {
            elem.requestFullscreen();
            this.isFullscreen = true;
            return;
          } else if (elem.webkitRequestFullscreen) {
            elem.webkitRequestFullscreen();
            this.isFullscreen = true;
            return;
          } else if (elem.mozRequestFullScreen) {
            elem.mozRequestFullScreen();
            this.isFullscreen = true;
            return;
          } else if (elem.msRequestFullscreen) {
            elem.msRequestFullscreen();
            this.isFullscreen = true;
            return;
          }
        } else {
          if (document.exitFullscreen) {
            document.exitFullscreen();
            this.isFullscreen = false;
            return;
          } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
            this.isFullscreen = false;
            return;
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
            this.isFullscreen = false;
            return;
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
            this.isFullscreen = false;
            return;
          }
        }
      }
    }
  },
  // component Lifecycle hooks
  beforeCreate() {},
  mounted() {}
};
</script>

<style scoped>
.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}

.full-screen-container {
  max-width: 100%;
  margin: 0;
}
</style>
